import { SearchFiltersToolbar } from 'app/domains/global-search';
import { useGetDefaultSearchFilters } from './useGetDefaultSearchFilters';
export function DefaultSearchFilters(props) {
    const { filters, actions, exclude = [] } = props;
    const { filterItems, loading } = useGetDefaultSearchFilters();
    return (<SearchFiltersToolbar loading={loading} actions={actions} filters={filters} filterItems={filterItems} exclude={exclude}/>);
}
